import React from 'react';
import ajaxError from '../../helpers/ajaxError'

import GamesFilterHead from '../GamesFilterHead.jsx';
import GamesFilterNavigation from '../GamesFilterNavigation.jsx';
import GfywList from './gfywList.jsx';

class Gfyw extends React.Component {

	render(){
		return (
			<React.Fragment>
				<div className="GameScreen-breadcrumb"></div>
				<header className="Category">
					<h2 className="Category-title">{translate.games_for_your_website}</h2>
					<nav id="GamesFilterHead" className="Category-secondaryNav">
						<ul>
							<GamesFilterHead noTopRated noMostPlayed />
						</ul>
					</nav>
				</header>
				<section className="Gfyw-list">
					<GfywList data={this.props.data} />
				</section>
				<section className="Games-pagination">
					<GamesFilterNavigation totalPages={this.props.meta.totalPages} />
				</section>
			</React.Fragment>
		)
	}
}

export default Gfyw;